import AppWrapper from "../../../components/cm/AppWrapper";
import UploadDocuments from "../../../components/modules/Documents/UploadDocuments";
import SideBarMain from "../../../components/cm/SideBarMain";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <UploadDocuments/>
    </AppWrapper.WithSidebar>
  );
};
